import VueI18n from 'vue-i18n';
import Vue from 'vue';
import LanguageStore from '@/store/language-store';

Vue.use(VueI18n);

const locales = {
  en: require('@/assets/js/locales/en.json'),
  fr: require('@/assets/js/locales/fr.json'),
};

const i18n = new VueI18n({
  locale: LanguageStore.getLanguage().languageCode,
  fallbackLocale: 'en',
  messages: locales,
});

export default i18n;
